import React from "react";
import "./styles/app.scss";
import QuestionScreen from "./components/QuestionScreen";
import useQuestions from "./components/hooks/useQuestions";
import ScoreScreen from "./components/ScoreScreen";

function App() {
  const [state, handlers] = useQuestions();

  return (
    <div className="App">
      {!state.isComplete ? (
        <QuestionScreen state={state} handlers={handlers} />
      ) : (
        <ScoreScreen questions={state.questions} />
      )}
    </div>
  );
}

export default App;
